import * as Redux from "redux";

import { AgentStatusPerAgentAndProcess } from "../model/AgentStatusPerAgentAndProcess";
import { Process } from "../model/Process";
import { ProcessCountState } from "../model/ProcessCountState";

import { ThunkResult } from "../../shared/utilities";
import { State } from "../model/State";
import { fetchProcessesByGuid, reportFetchError } from "./FetchActions";

export function updateProcesses(type: "Created" | "Updated" | "Deleted", environmentName: string, agentGroupName: string | null, processGuids: string[]):
    ThunkResult<void, State> {
    return (dispatch, getState) => {
        const currentProcessGuids = getState().processes.map(x => x.uniqueIdentifier);
        const updatedProcessGuids = processGuids.filter(x => currentProcessGuids.some(cProcesses => cProcesses == x));
        // Only fetch up that are visible / wihin this page
        if (updatedProcessGuids.length > 0) {
            switch (type) {
                case "Created":
                    // newly created processes can't be in the list of current processes
                    return;
                case "Updated":
                    return fetchProcessesByGuid(environmentName, agentGroupName, updatedProcessGuids)
                        .then((processData) => {
                            return dispatch(getUpdateProcessesAction(processData));
                        })
                        .catch((exception) => dispatch(reportFetchError(exception)));

                case "Deleted":
                    return dispatch(processDeleted(updatedProcessGuids));

                default: {
                    const err = `Cannot process processUpdate message: Unknown notification type '${type}'.`;
                    return dispatch(reportFetchError(err));
                }
            }
        }
    };
}

export const UPDATE_PROCESSES = "UPDATE_PROCESSES";
export interface UpdateProcessesAction extends Redux.Action {
    processes: Process[];
}

export function getUpdateProcessesAction(processes: Process[]): UpdateProcessesAction {
    return {
        type: UPDATE_PROCESSES,
        processes: processes
    };
}

export const UPDATE_AGENT_STATUSES = "UPDATE_AGENT_STATUSES";
export function updateAgentStatuses(data: AgentStatusPerAgentAndProcess): AgentStatusUpdateAction {
    return {
        type: UPDATE_AGENT_STATUSES,
        agentStatuses: data
    };
}

export interface AgentStatusUpdateAction extends Redux.Action {
    agentStatuses: AgentStatusPerAgentAndProcess;
}

export const RESET_PROCESS_COUNTS = "RESET_PROCESS_COUNTS";
export function resetProcessCounts(data: ProcessCountState): ReceiveProcessCountsAction {
    return {
        type: RESET_PROCESS_COUNTS,
        processCounts: data
    };
}

export const UPDATE_PROCESS_COUNTS = "UPDATE_PROCESS_COUNTS";
export function updateProcessCounts(data: ProcessCountState): ReceiveProcessCountsAction {
    return {
        type: UPDATE_PROCESS_COUNTS,
        processCounts: data
    };
}

export const DELETE_PROCESSES = "DELETE_PROCESSES";
export function processDeleted(processIds: string[]): ProcessesDeletedAction {
    return {
        type: DELETE_PROCESSES,
        processIds: processIds
    };
}
export interface ProcessesDeletedAction extends Redux.Action {
    processIds: string[];
}

export interface ReceiveProcessCountsAction extends Redux.Action {
    processCounts: ProcessCountState;
}
